export const CHANGE_CURRENT_PAGE = 'eternalLists/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'eternalLists/CHANGE_PAGE_SIZE'
export const CREATE_ETERNAL_LIST_ITEMS = 'eternalLists/CREATE_ETERNAL_LIST_ITEMS'
export const FETCH_ETERNAL_LIST = 'eternalLists/FETCH_ETERNAL_LIST'
export const REMOVE_ETERNAL_LIST_ITEMS = 'eternalLists/REMOVE_ETERNAL_LIST_ITEMS'
export const UPDATE_ETERNAL_LIST_ITEM = 'eternalLists/UPDATE_ETERNAL_LIST_ITEM'
